import { GameStatistic, Sport } from '@/types';

const FOOTBALL_MAIN_STAT_PATTERNS: RegExp[] = [
  /^posse de bola$|^possession$/,
  /^gols esperados|^expected goals|^xg$/,
  /^total de chutes$|^finalizacoes$|^total shots$|^shots total$/,
  /^chutes no gol$|^chutes no alvo$|^shots on goal$|^shots on target$/,
  /^chances perigosas criadas$|^big chances$|^dangerous attacks$/,
  /^escanteios$|^corners$/,
  /^impedimentos$|^offsides$/,
  /^faltas$|^fouls$/,
  /^cartoes amarelos$|^yellow cards$/,
  /^cartoes vermelhos$|^red cards$/,
  /^ataque$|^attacks$/,
  /^passes completos$|^total de passes$|^passes completed$/,
];

function normalizeStatLabel(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function footballStatRank(stat: GameStatistic): number {
  const label = normalizeStatLabel(stat.label);
  const index = FOOTBALL_MAIN_STAT_PATTERNS.findIndex((pattern) => pattern.test(label));
  return index === -1 ? Number.POSITIVE_INFINITY : index;
}

export function getMainStatistics(stats: GameStatistic[], sport: Sport, limit = 12): GameStatistic[] {
  if (stats.length <= limit && sport !== 'futebol') return stats;
  if (sport !== 'futebol') return stats.slice(0, limit);

  const seen = new Set<string>();
  const main = stats
    .map((stat, index) => ({ stat, index, rank: footballStatRank(stat) }))
    .filter((item) => Number.isFinite(item.rank))
    .sort((a, b) => a.rank - b.rank || a.index - b.index)
    .filter(({ stat }) => {
      const key = normalizeStatLabel(stat.label);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map(({ stat }) => stat)
    .slice(0, limit);

  return main.length > 0 ? main : stats.slice(0, limit);
}
